import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterOutlet, RouterLink } from '@angular/router';
import { BreadcrumbService } from '../../../core/services/breadcrumb/breadcrumb.service';

@Component({
  selector: 'app-practical-classes',
  standalone: true,
  imports: [CommonModule, RouterOutlet, RouterLink],
  templateUrl: './practical-classes.component.html',
  styleUrl: './practical-classes.component.css'
})
export class PracticalClassesComponent {
  constructor(private router: Router) {}

  isActive(path: string): boolean {
    return this.router.url.includes(path);
  }
}
